import React, { useState, useEffect, useContext, forwardRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, styled, Snackbar, Checkbox } from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import Clear from "@mui/icons-material/Clear";
import MuiAlert from "@mui/material/Alert";
import { DeleteDialog } from "../components/DeleteDialog";
import { Link } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {
  collection,
  query,
  where,
  getDocs,
  or,
  onSnapshot,
} from "firebase/firestore";
import { setDoc, doc } from "firebase/firestore";
import { Context } from "context/Wrapper";
import { db } from "config/config";
import { listenAndFilterTo, useAdvancedDataListener } from "apis/dataSnapshots";
import AdvancedTable from "components/AdvancedTable";
import useCustomParams from "components/shared/useCustomParams";
import tableConfig from "config/advancedTableColumnsControl.json";
import { getContactColumnsWithHighlighting, getContactDateUpdatedColumn } from "config/contactColumns";


const searchLimit = tableConfig?.searchMinLength;

// const ListItem = styled(Paper)(({ theme, ...rest }) => {
//   return {
//     width: "100%",
//     padding: theme.spacing(1),
//     textAlign: "left",
//     marginTop: theme.spacing(2),
//     marginBottom: 0,
//     color: theme.palette.primary.main,
//     background: rest?.userGroupCheck
//       ? theme.palette.secondary.secondary
//       : theme.palette.secondary.main,
//   };
// });


const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export const Contacts = (props) => {



  const contactLocationState = useLocation()

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: contactLocationState.state?.feedback?.message ? true : false,
    message: contactLocationState.state?.feedback ? contactLocationState.state?.feedback?.message : '',
    severity: contactLocationState.state?.feedback ? contactLocationState.state?.feedback?.severity : 'success',
  });



  const [contactExtraFilters, setContactExtraFilters] = useState({
    architect: false,
    client: false,
    contractor: false,
    employee: false,
    engineer: false,
    filingRep: false,
    owner: false,
    tenant: false
  })

  const dateUpdatedColumn = {
    field: "dateUpdated",
    headerName: "Last Updated",
    renderCell: ({ row }) => {
      if (!row.dateUpdated) return "";
      const d = typeof row.dateUpdated === "number"
        ? new Date(row.dateUpdated)
        : row.dateUpdated.toDate();
      return d.toISOString().split("T")[0];
    },
    sortComparator: (_, __, c1, c2) => {
      const a = c1.row.dateUpdated, b = c2.row.dateUpdated;
      const ms1 = typeof a === "number" ? a : a?.toMillis?.() || 0;
      const ms2 = typeof b === "number" ? b : b?.toMillis?.() || 0;
      return ms1 - ms2;
    },
  };



  const context = useContext(Context);
  const { params, updateParams } = useCustomParams();
  const sortField = params.get("sort") || "";
  const sortOrder = params.get("order") || "asc";
  useEffect(() => {
    const gridFilter = params.get("search") || "";
    setSearchValue(gridFilter);
  }, [params.get("search")]);


  const { groupId, isPro } = context?.state?.userProfile || {};
  const user = context?.state?.userProfile || {},
    { showAllDataFlag } = context?.state || {};

  // const { db, user, groupId, allData, isPro } = props;

  const [contacts, setContacts] = useState([]);

  const navigate = useNavigate();

const fetchAndSearchAllContacts = async () => {
  const contactsRef = collection(db, "contacts");
  let baseConditions = [];
  
  if (showAllDataFlag && groupId) {
    baseConditions.push(where("groupId", "==", groupId));
  } else if (!showAllDataFlag && user?.userId) {
    baseConditions.push(where("userId", "==", user.userId));
  }
  
  const q = query(contactsRef, ...baseConditions);
  const snapshot = await getDocs(q);

  const allDocs = snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
  }));

  const anyFilterActive = Object.values(contactExtraFilters).some(Boolean);
  let filteredData = allDocs;

  if (anyFilterActive) {
    filteredData = filteredData.filter((contact) =>
      Object.keys(contactExtraFilters).some(
        (key) => contactExtraFilters[key] && contact[key]
      )
    );
  }

  const queryLower = searchValue.toLowerCase();
  filteredData = filteredData
    .filter((item) =>
      item.fullName?.toLowerCase().includes(queryLower) ||
      item.businessName?.toLowerCase().includes(queryLower) ||
      item.phone?.toLowerCase().includes(queryLower) ||
      item.email?.toLowerCase().includes(queryLower)
    )
    .map((item) => {
      const highlight = (val) =>
        val?.replace(
          new RegExp(searchValue, "gi"),
          (match) =>
            `<mark style="background: #2769AA; color: white;">${match}</mark>`
        );
      return {
        ...item,
        displayFullName: highlight(item.fullName),
        displayBusinessName: highlight(item.businessName),
        displayPhone: highlight(item.phone),
        displayEmail: highlight(item.email),
      };
    });
  filteredData.sort((a, b) =>
    String(a.fullName_lc || "").localeCompare(String(b.fullName_lc || ""))
  );

  setFilteredContacts(filteredData);
};

  const [deleteOpen, setDeleteOpen] = useState(false);

  const [itemToDelete, setItemToDelete] = useState({
    itemId: "",
    identifier: "",
  });

  const [filteredContacts, setFilteredContacts] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  const { data, count, refetch } = useAdvancedDataListener({
    user,
    // conditions,
    // setLastRef: setLastVisible,
    condition: groupId && isPro && showAllDataFlag,
    collectionName: "contacts",
    defaultSortField: "fullName_lc",
    defaultSortOrder: "asc",

    contactExtraFilters
    // rowsLimit,
    // params,
  });

  useEffect(() => {
    updateParams({
      page: "",
      search: "",
      pageIncreasing: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setContacts(data);
  }, [data]);

  useEffect(() => {
    if (searchValue.length >= searchLimit) {
      fetchAndSearchAllContacts();
    }
  }, [sortField, sortOrder]);


  useEffect(() => {
    if (searchValue.length >= searchLimit) {
      fetchAndSearchAllContacts();
    } else {
      setFilteredContacts([]);
    }
  }, [searchValue, showAllDataFlag, contactExtraFilters]);


  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  const handleTrackChange = async (event, id) => {
    const thisContact = doc(db, "contacts", id);
    setDoc(thisContact, { track: event.target.checked }, { merge: true }).then(
      () => {
        console.log("updated");
      }
    );
  };

  const handleDelete = (id, identifier, row) => {
    console.log(row);
    setItemToDelete({ itemId: id, identifier: row.fullName });
    setDeleteOpen(true);
  };

  const confirmDelete = async () => {
    await db.collection("contacts").doc(itemToDelete.itemId).delete();
    setContacts((prevContacts) =>
      prevContacts.filter((contact) => contact.id !== itemToDelete.itemId)
    );

    refetch();  // Trigger a fresh fetch of the count and data

    openFeedbackMessage('Contact deleted successfully!', 'success');

    setItemToDelete({ itemId: "", identifier: "" });
    setDeleteOpen(false);
    navigate("/contacts");
  };

  const searchCheck = searchValue.length >= searchLimit;

  const contactCollection = searchCheck ? filteredContacts : contacts;




  const openFeedbackMessage = (message, severity) => {
    setFeedbackMessage({ open: true, message, severity });
  };

  const handleCloseFeedbackMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFeedbackMessage({ ...feedbackMessage, open: false });
  };


  return (
    <>
      <Fade in={true}>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={8} style={{ position: "sticky" }}>
              <Typography align="left" variant="h4">
                CONTACTS
              </Typography>
            </Grid>



            <Grid item xs={12} md={6} lg={4}>
              <Paper
                component="form"
                onSubmit={(e) => e.preventDefault()}
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginLeft: "auto",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  value={searchValue}
                  inputProps={{ "aria-label": "search" }}
                  onInput={handleSearch}
                />
                {searchCheck ? (
                  <IconButton
                    sx={{ p: "10px" }}
                    aria-label="search"
                    onClick={() => {
                      setSearchValue("");
                      updateParams({ search: "" });
                    }}
                  >
                    <Clear />
                  </IconButton>
                ) : (
                  <IconButton sx={{ p: "10px" }} aria-label="clear">
                    <SearchIcon />
                  </IconButton>
                )}
              </Paper>
            </Grid>


            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                my: 2,
                p: 2,
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Typography variant="h6">Filter By: </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                {Object.keys(contactExtraFilters).map((filter) => (
                  <Box
                    key={filter}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography>{filter.charAt(0).toUpperCase() + filter.slice(1)}</Typography>
                    <Checkbox
                      checked={contactExtraFilters[filter]}
                      onChange={() =>
                        setContactExtraFilters((prev) => ({
                          ...prev,
                          [filter]: !prev[filter],
                        }))
                      }
                      color="primary"
                    />
                  </Box>
                ))}
              </Box>
            </Box>


          </Grid>



          <AdvancedTable
            data={contactCollection}
            collectionName="contacts"
            contactExtraFilters={contactExtraFilters}
columnsRaw={[
  ...getContactColumnsWithHighlighting(),
  ...(tableConfig.contacts.dateUpdated ? [getContactDateUpdatedColumn()] : []),
]}
            rowCount={searchCheck ? contactCollection?.length : count}
            handleDelete={handleDelete}
            isInactive={props.isInactive}
          />

          <Box
            sx={{
              position: "fixed",
              bottom: "1rem",
              "& > :not(style)": { m: 1 },
            }}
          >
            {!props.isInactive && (
              <Link to="/contacts/new">
                <Fab
                  color="primary"
                  aria-label="add"
                  variant="extended"
                  disabled={props.isInactive}
                >
                  <AddIcon sx={{ mr: 1 }} />
                  New
                </Fab>
              </Link>
            )}
          </Box>
        </div>
      </Fade>
      <DeleteDialog
        open={deleteOpen}
        confirmDelete={confirmDelete}
        setDialogOpen={setDeleteOpen}
        identifier={itemToDelete.identifier}
      />
      <Snackbar
        open={feedbackMessage.open}
        autoHideDuration={2000}
        onClose={handleCloseFeedbackMessage}
      >
        <Alert
          onClose={handleCloseFeedbackMessage}
          severity={feedbackMessage.severity}
          sx={{ width: "100%" }}
        >
          {feedbackMessage.message}
        </Alert>
      </Snackbar>
    </>
  );
};
